import React from 'react';
import styles from './CoachLandingPage.module.css';
import ContactForm from '../contactForm/ContactForm'

const CoachLandingPage = () => {
  return (
    <div className={styles.pageWrapper}>
      <div className={styles.backgroundImage}></div>
      <div className={styles.contentWrapper}>
        <section className={styles.hero}>
          <h1>Unlock Your Tech Skills. Let’s Build.</h1>
          <p> 
            Stuck on a project, prepping for interviews, or tired of tutorials that don’t cut it? We’ll tackle it together and get you real, actionable results. No fluff. Just results.  
          </p>
          <ul className={styles.featureList}>
            <li>Build real-world projects with immediate impact</li>
            <li>Learn AI tools like ChatGPT, Copilot, and more</li>
            <li>Polish your resume and ace interviews with confidence</li>
            <li>Get hands-on with CRM systems (Salesforce, HubSpot) and integrations</li>
            <li>Build websites with WordPress, no-code builders, or custom solutions</li>
            <li>Optimize workflows with tools like QuickBooks, Zapier, and automation platforms</li>
            <li>Learn the fundamentals of app development, cloud platforms, and tech architecture</li>
            <li>Get expert guidance for breaking into tech and advancing your career</li>
          </ul>

        </section>

        <section className={styles.consultSection} id="consult-form">
          <h2>Let's Chat!</h2>
          <p>Tell me what you're working on — no pressure, just straight-up advice.</p>
          <ContactForm />
        </section>
      </div>

    </div>
  );
};

export default CoachLandingPage;
